import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';
import { IonicLoaderModule } from '@epicuro-next/platform/ionic-loader';

import { ServicenowVirtualAgentComponent } from './components/servicenow-virtual-agent/servicenow-virtual-agent.component';
import { IServicenowVirtualAgentConfig } from './interfaces/servicenow-virtual-agent.interface';
import { SERVICENOW_VIRTUAL_AGENT_CONFIG_TOKEN } from './tokens';

export function getConfig(
  environmentSettings: EnvironmentSettings,
): IServicenowVirtualAgentConfig | null {
  if (!environmentSettings.servicenowVirtualAgent) {
    return null;
  }

  let config: IServicenowVirtualAgentConfig | null = null;
  if (environmentSettings.servicenowVirtualAgent) {
    try {
      config = JSON.parse(environmentSettings.servicenowVirtualAgent);
    } catch (exception) {
      console.warn(
        'Could not parse the configuration for Servicenow Virtual Agent',
        { exception, config: environmentSettings.servicenowVirtualAgent },
      );
    }
  }

  return config;
}

@NgModule({
  imports: [
    CommonModule,
    IconsModule,
    IonicLoaderModule.forRoot(),
    DomSanitizerModule,
  ],
  declarations: [ServicenowVirtualAgentComponent],
  exports: [ServicenowVirtualAgentComponent],
  providers: [
    {
      provide: SERVICENOW_VIRTUAL_AGENT_CONFIG_TOKEN,
      useFactory: getConfig,
      deps: [ENVIRONMENT_SETTINGS],
    },
  ],
})
export class ServicenowVirtualAgentModule {}
